var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_5782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0C25.3137 2.57702e-07 28 2.68629 28 6V22C28 25.3137 25.3137 28 22 28H6C2.68629 28 3.22139e-08 25.3137 0 22V6C2.57711e-07 2.68629 2.68629 3.22128e-08 6 0H22ZM6 5V22.9121L6.08789 23H11.9609V19.1719C11.961 19.1134 11.994 19.0046 12.0488 18.9678H14.0068V21.0127C14.6735 20.9449 15.391 20.8982 16.0518 21.0127V23H22.0127V17.0391H20.0557L19.9678 16.9512V14.9932H17.9805V13.0068H19.9678V11.0488L20.0557 10.9609H22.0127V5H16.0518V6.95801L15.9199 7.03418L14.0068 6.9873V9.03223H12.0488L11.9609 8.94434V5H6Z",
    fill: "#4FF317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.961 5V8.94481L12.0487 9.03247H14.0065V6.98701L15.9199 7.03435L16.0519 6.95779V5H22.013V10.961H20.0552L19.9675 11.0487V13.0065H17.9805V14.9935H19.9675V16.9513L20.0552 17.039H22.013V23H16.0519V21.013C15.391 20.8984 14.6733 20.9452 14.0065 21.013V18.9675H12.0487C11.9938 19.0044 11.961 19.1136 11.961 19.1721V23H6.08766L6 22.9123V5H11.961Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_5782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKImage);
export default __webpack_public_path__ + "static/media/k-image.0e3a7466b2a9ff5497a3910cacce8c7a.svg";
export { ForwardRef as ReactComponent };